import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de Seguridad
 * - Cambio de contraseÃ±a, 2FA, dispositivos activos, cierre de sesiÃ³n global
 * - Extensible para integraciÃ³n con servicios de autenticaciÃ³n y logs
 */
export default function SecuritySection() {
    return (
        <Box>
            <Typography variant="h6">Seguridad</Typography>
            {/* TODO: Controles de seguridad */}
            <Typography variant="body2" color="text.secondary">
                Gestiona tu contraseÃ±a, autenticaciÃ³n en dos pasos y dispositivos activos.
            </Typography>
        </Box>
    );
} 